$.fn.CartForm = function(options) {
  let self = this

  self.options = $.extend(true, {
    select: false,
    main: self.parent(),
    parent: self.parent(),
  }, options)

  self.is_variable = false
  self.quantity = undefined
  self.button = self.find('.single_add_to_cart_button')
  self.variations = {}
  self.current_variation = undefined

  /*
  * Add to cart
  */
  self.add_to_cart = function(e) {
    e.preventDefault()

    /* Block UI */
    self.block({
      message: null,
      overlayCSS: {
        'background-color': '#fff8f3',
      },
    })

    /* Prepare data to cart */
    let add_item_data = {
      'quantity': self.find('input[name="quantity"]').val(),
      'product_id': self.find('[name="add-to-cart"]').val(),
      'product_sku': self.find('[name="product-sku"]').val(),
    }
    if (self.find('input[name="variation_id"]').length) {
      add_item_data.product_id = self.find('input[name="variation_id"]').val()
    }

    /* Post to cart */
    $.post(melia_l10n.home_url + '?wc-ajax=add_to_cart', add_item_data, function(x) {
      $.mlmi.cart.fragmentsRefreshed(x)
    })
  }

  /*
  * Update price
  */
  self.update_price = function() {
    /* Check for quantity select (stock) */
    if (self.quantity == undefined || !self.quantity.length) {
      return
    }

    /* Get quantity and prepare */
    let current_quantity = parseInt(self.quantity.val(), 10)
    self.button.find('.price').remove()

    /* Find price display */
    let price_display = undefined
    if (!self.is_variable) {
      price_display = self.options.main.find('> .price').first().clone()
      // if (!price_display.length) {
      //   price_display = self.options.main.find('> .woocommerce-Price-amount bdi').first().clone()
      // }
    } else if (self.is_variable && self.current_variation != undefined) {
      price_display = self.options.parent.find('.woocommerce-variation-price ins .woocommerce-Price-amount bdi').first().clone()
      if (!price_display.length) {
        price_display = self.options.parent.find('.woocommerce-variation-price .woocommerce-Price-amount bdi').first().clone()
      }
    }

    /* Display price on button */
    if (price_display != undefined && price_display.length) {
      if (!price_display.hasClass('price')) {
        price_display = $('<span class="price"></span>').append(price_display)
      }
      let currency_format = price_display.find('.woocommerce-Price-currencySymbol').first().clone()
      if (price_display.find('del').length) {
        let del_unit_price = parseFloat(price_display.find('del').text()) * current_quantity,
        ins_unit_price = parseFloat(price_display.find('ins').text()) * current_quantity
        price_display.find('del bdi').html(del_unit_price.toLocaleString('fr-CA', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).replace(',', '.') + '&nbsp;').append(currency_format)
        price_display.find('ins bdi').html(ins_unit_price.toLocaleString('fr-CA', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).replace(',', '.') + '&nbsp;').append(currency_format)
      } else {
        let unit_price = parseFloat(price_display.text()) * current_quantity
        price_display.find('bdi').html(unit_price.toLocaleString('fr-CA', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).replace(',', '.') + '&nbsp;').append(currency_format)
      }
      self.button.prepend(price_display)
    }
  }

  /*
  * Initialize interface
  */
  self.initialize_interface = function() {
    /* Wrap button label */
    self.button.wrapInner('<span class="add-to-cart-label">')

    /* Quantity input */
    self.find('input.qty').each(function() {
      self.quantity = $(this).Quantity()
      self.quantity.on('change', self.update_price)
    })

    /* Always force first option to be selected */
    if (!self.options.select) {
      self.find('table.variations select').each(function() {
        $(this).find('option[value!=""]').first().prop('selected', true)
        $(this).trigger('change')
      })
    }

    /* Select element */
    self.find('table.variations select').each(function() {
      self.is_variable = true
      let attribute_name = $(this).attr('name'),
      variations_data = self.data('product_variations')
      variations_data.forEach(function(variation) {
        let variation_name = variation.attributes[attribute_name]
        self.variations[variation_name] = variation.select_price
      })
      if (self.options.select) {
        $(this).find('option').each(function() {
          if ($(this).val()) {
            let variation_name = $(this).attr('value')
            $(this).data('display', variation_name + ' - ' + self.variations[variation_name])
            $(this).data('option-display', variation_name + ' - ' + self.variations[variation_name])
          }
        })
        $(this).Select().getSelect().addClass('select--variations')
      }
    })

    /* Variation magic */
    self.find('.single_variation_wrap').on('show_variation', function(e, variation) {
      self.current_variation = variation
      self.quantity.initialize_limits()
      self.update_price()
    })
  }

  return function() {
    self.initialize_interface()
    self.update_price()
    self.on('submit', self.add_to_cart)
    return self
  }()
}
